// Preferências de tela (tema, velocidade do áudio, seções abertas do menu).
//
// Guardadas em cookie, não em localStorage. Não é questão de segurança — isto
// aqui não tem segredo nenhum — é de manter um único lugar de armazenamento no
// navegador: com o token fora do localStorage, deixar sobras ali só convida a
// alguém a voltar a usá-lo para algo sensível.
//
// São cookies comuns (o JavaScript precisa lê-los para pintar a tela antes de
// qualquer requisição) e viajam junto com cada chamada à API. Por isso valem
// só para valores curtos: um tema, um número, um "aberto/fechado".

const UM_ANO = 365 * 24 * 60 * 60;

export const lerPreferencia = (chave, padrao = null) => {
	try {
		const alvo = `${encodeURIComponent(chave)}=`;
		const achado = document.cookie
			.split("; ")
			.find(parte => parte.startsWith(alvo));

		if (!achado) return padrao;

		const bruto = decodeURIComponent(achado.slice(alvo.length));

		return bruto === "" ? padrao : JSON.parse(bruto);
	} catch {
		// Cookie corrompido não pode derrubar a tela: vale o padrão.
		return padrao;
	}
};

export const gravarPreferencia = (chave, valor) => {
	try {
		const corpo = encodeURIComponent(JSON.stringify(valor));

		// SameSite=Lax porque nada aqui deve viajar em requisição de outro site.
		document.cookie = `${encodeURIComponent(
			chave
		)}=${corpo}; path=/; max-age=${UM_ANO}; SameSite=Lax`;
	} catch {
		// Preferência que não grava só volta ao padrão na próxima visita.
	}
};
